import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useCreateBillRateMutation } from 'queries/billRates/useCreateBillRateMutation'

type CreateBillRateFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      isError: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<typeof useCreateBillRateMutation>['mutate']
    reset: ReturnType<typeof useCreateBillRateMutation>['reset']
  }
}

const [Context, useCreateBillRateFlowContextValue] =
  createContext<CreateBillRateFlowContextState>({
    name: 'CreateBillRateFlowContext',
  })

export const CreateBillRateFlowProvider = ({ children }: PropsWithChildren) => {
  const { mutate, reset, isPending, isError, error } =
    useCreateBillRateMutation()

  const value: CreateBillRateFlowContextState = {
    state: {
      mutationState: {
        isPending,
        isError,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: {
      submit: mutate,
      reset,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useCreateBillRateFlowContextValue }
